import React from 'react';
import { IApplicationContext } from '../IApplicationContext';

interface IContext extends IApplicationContext {
	canLaunch: boolean;
}

export const HamsClientApplicationContext = React.createContext<IContext>(undefined as any);
